export const conversations = state => state.all
